import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Navigation from './components/Navigation/Navigation';
import Footer from './components/Footer/Footer';
import SocialFloatingButton from './components/SocialFloatingButton/SocialFloatingButton';
import { LanguageProvider } from './contexts/LanguageContext';
import Home from './pages/Home';
import About from './pages/About';
import Classes from './pages/Classes';
import Pricing from './pages/Pricing';
import Booking from './pages/Booking';
import Contact from './pages/Contact';
import BecomeTeacher from './pages/BecomeTeacher';
import Gallery from './pages/Gallery';
import Trainers from './pages/Trainers';
import YogaCourses from './pages/YogaCourses';
import Login from './pages/Login';
import Register from './pages/Register';
import InstitutionRegister from './pages/InstitutionRegister';
import StudioRegister from './pages/StudioRegister';
import UserDashboard from './pages/UserDashboard';
import TeacherDashboard from './pages/TeacherDashboard';
import AdminDashboard from './pages/AdminDashboard';
import InstitutionDashboard from './pages/InstitutionDashboard';
import StudioDashboard from './pages/StudioDashboard';
import ServiceDetail from './pages/ServiceDetail';
import PartnerRegistration from './pages/PartnerRegistration';
import CurtainIntro from './components/CurtainIntro/CurtainIntro';
import Community from './pages/Community';

import ScrollToTop from './components/ScrollToTop/ScrollToTop';

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname === '/admin/dashboard';
  const isCommunityRoute = location.pathname === '/community';

  return (
    <div className="App">
      <ScrollToTop />
      <Navigation />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/classes" element={<Classes />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/trainers" element={<Trainers />} />
          <Route path="/yoga-courses" element={<YogaCourses />} />
          <Route path="/become-teacher" element={<BecomeTeacher />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/register/institution" element={<InstitutionRegister />} />
          <Route path="/register/studio" element={<StudioRegister />} />
          <Route path="/user/dashboard" element={<UserDashboard />} />
          <Route path="/teacher/dashboard" element={<TeacherDashboard />} />
          <Route path="/institution/dashboard" element={<InstitutionDashboard />} />
          <Route path="/studio/dashboard" element={<StudioDashboard />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/service/:slug" element={<ServiceDetail />} />
          <Route path="/register/partner" element={<PartnerRegistration />} />
          <Route path="/community" element={<Community />} />
          {/* Catch all route for 404 */}
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      {!isAdminRoute && !isCommunityRoute && <Footer />}

      {/* Global Floating Action Buttons */}
      {!isAdminRoute && !isCommunityRoute && <SocialFloatingButton />}
      
      {/* Notifications */}
      <ToastContainer position="top-right" autoClose={3000} />

      {/* <a
        href="https://wa.me/919876543210"
        className="fab fab-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
      >
        
        <i className="bi bi-whatsapp"></i>
        <img src="whatsapp.png" alt="WhatsApp" style={{width:"60px",height:"56px"}}/>



        </a> */}


    </div>
  );
}




function App() {
  return (
    <LanguageProvider>
      <Router>
        {/* TODO: REMOVE AFTER LAUNCH */}
        <CurtainIntro>
          <AppContent />
        </CurtainIntro>
      </Router>
    </LanguageProvider>
  );
}

export default App;
